import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableHeadSelect, Typography } from '../../../../../ui-kit';
import { WarehouseLeftoversHeaderContent, WarehouseNameHeaderContent } from './HeaderCell';
import { AdditionalTableHeadProps } from './types';


const WarehouseCardTableHeadCell = ({
    index,
    headCell,
    checked,
    indeterminate,
    onChange,
    isActionActive,
    name,
    warehouseCategory,
    leftOvers,
}: AdditionalTableHeadProps) => {
    const { t } = useTranslation();

    let tableHeadCellContent;
    switch (headCell.id) {

        case 'name': {
            tableHeadCellContent = (
                <WarehouseNameHeaderContent
                    index={index}
                    headCell={headCell}
                    checked={checked}
                    indeterminate={indeterminate}
                    onChange={onChange}
                    isActionActive={isActionActive}
                    {...name}
                />
            );
            break;
        }
        case 'warehouseCategory': {
        // eslint-disable-next-line @typescript-eslint/unbound-method
            const { selectedCategoryId, setSelectedCategoryId, categoryOptions } = warehouseCategory;

            tableHeadCellContent = (
                <TableHeadSelect
                    fullWidth
                    label={t('Warehouse category')}
                    value={selectedCategoryId}
                    onChange={setSelectedCategoryId}
                    options={categoryOptions}
                />
            );
            break;
        }
        case 'leftOvers': {
            tableHeadCellContent = (
                <WarehouseLeftoversHeaderContent
                    {...leftOvers}
                />
            );
            break;
        }
        default:
            tableHeadCellContent = <Typography uppercase color='textSecondary' variant='caption'>{t(...headCell.label)}</Typography>;
    }

    const isSticky = index === 0;
    return (
        <TableCell
            id={headCell.id as string}
            key={headCell.id as string}
            align={headCell.align}
            isTableHead
            isSticky={isSticky}
            padding='none'
        >
            {tableHeadCellContent}
        </TableCell>
    );
};

export default WarehouseCardTableHeadCell;
